import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import CryptoJS from "crypto-js";
import { TextInput, SelectInput } from "../../../../Components";
import { storageHandler } from "../../../../Helpers";
import { SwitchWithLabel } from "../../../../Components/AppSwitchWithLabel";
import { jobCampaignsService } from "../../../../Services";
import AppTextArea from "../../Form/AppTextArea";

const timeFrame = [
  { id: "seconds", value: "Seconds" },
  { id: "minutes", value: "Minutes" },
  { id: "hours", value: "Hours" },
];
export default function AddOffer({
  influencerUserType,
  user,
  setShowCart,
  instModul,
  fcbkModul,
  tiktokModul,
  youtubeModul,
  setModal,
  setToastList,
  toastList,
  setCartItem,
  cartItem,
  influencerProfile,
  selectedApplication,
  isReadOnlyOffer,
  selectedOfferData,
}) {
  console.log("🚀 ~ AddOffer ~ selectedOfferData:", selectedOfferData);
  console.log("🚀 ~ AddOffer ~ isReadOnlyOffer:", isReadOnlyOffer);
  const secretKey = process.env.REACT_APP_SECRET_KEY;

  const currentUrl = window.location.href;
  const isInfluencerProfilePage = currentUrl.includes("influencerProfile");

  const initForm = {
    product: selectedOfferData?.product_id || "",
    pieceOfContent: selectedOfferData?.rate ? "1" : "",
    time: "",
    timespan: "",
    rate: selectedOfferData?.rate || "",
    platform_user_id: selectedOfferData?.pt_user_id || "",
    ds_campaign_title: "",
    ds_campaign_delivery_info: "",
    ds_campaign_delivery_date: "",
    brand_profile_id: "",
  };
  const createList = useRef(null);
  const [form, setForm] = useState(initForm);
  const [error, setError] = useState(false);
  const [productList, setProductList] = useState([]);
  const [followersList, setFollowersList] = useState({
    instagram: [],
    facebook: [],
    youtube: [],
    tiktok: [],
  });
  const [selPlatform, setSelPlatform] = useState(null);
  const [showFollowersDropdown, setShowFollowersDropdown] = useState(false);
  const [followersDropdown, setFollowersDropdown] = useState([]);
  const [paymentEnabled, setPaymentEnabled] = useState(true);
  const [isStartDatePickerOpen, setIsStartDatePickerOpen] = useState(false);
  const [brandProfilesList, setBrandProfilesList] = useState([]);

  useEffect(() => {
    fetchBrandProfiles();
  }, []);

  const fetchBrandProfiles = async () => {
    try {
      const res = await jobCampaignsService.getBrandProfiles();
      if (res.success === true) {
        const updatedPlatforms = res?.data.map(({ id, brand_name }) => ({
          id: String(id),
          label: String(id),
          value: brand_name,
        }));
        setBrandProfilesList(updatedPlatforms);
        if (updatedPlatforms.length === 1) {
          updateForm({ brand_profile_id: updatedPlatforms[0].id });
        }
      }
    } catch (err) {
      console.log("🚀 ~ fetchBrandProfiles ~ err:", err);
    }
  };

  const updateForm = (data) => {
    setForm({ ...form, ...data });
  };
  const setInput = (key) => (event) =>
    updateForm({ [key]: event.target.value });

  const changeBrandProfile = (brandId) => {
    updateForm({ brand_profile_id: brandId });
  };

  const getSelectedBrandProfile = () => {
    return (
      brandProfilesList.find(
        (brand) => brand.id === parseInt(form.brand_profile_id)
      ) || null
    );
  };

  useEffect(() => {
    let platform = [];
    let platform_id_list = {
      instagram: [],
      facebook: [],
      youtube: [],
      tiktok: [],
    };
    let followersData = {
      instagram: [],
      facebook: [],
      youtube: [],
      tiktok: [],
    };

    // Instagram
    if (instModul?.length > 0) {
      instModul.map((item) => {
        platform.push({
          id: item.product_id,
          value: item.name,
          label: item.name,
          platform: "instagram",
          pt_user_id: item.pt_user_id,
        });
      });

      if (instModul.length > 1) {
        instModul.map((item) => {
          followersData.instagram.push({
            value: item.followers + " Followers",
            id: item.pt_user_id,
            label: item.followers + " Followers",
          });
        });
      } else {
        platform_id_list.instagram.push({ id: instModul[0].pt_user_id });
      }
    }

    // Facebook
    if (fcbkModul?.length > 0) {
      fcbkModul.map((item) => {
        platform.push({
          id: item.product_id,
          value: item.name,
          label: item.name,
          platform: "facebook",
          pt_user_id: item.pt_user_id,
        });
      });

      if (fcbkModul.length > 1) {
        fcbkModul.map((item) => {
          followersData.facebook.push({
            value: item.followers + " Followers",
            id: item.pt_user_id,
            label: item.followers + " Followers",
          });
        });
      } else {
        platform_id_list.facebook.push({ id: fcbkModul[0].pt_user_id });
      }
    }

    // YouTube
    if (youtubeModul?.length > 0) {
      youtubeModul.map((item) => {
        platform.push({
          id: item.product_id,
          value: item.name,
          label: item.name,
          platform: "youtube",
          pt_user_id: item.pt_user_id,
        });
      });

      if (youtubeModul.length > 1) {
        youtubeModul.map((item) => {
          followersData.youtube.push({
            value: item.followers + " Followers",
            id: item.pt_user_id,
            label: item.followers + " Followers",
          });
        });
      } else {
        platform_id_list.youtube.push({ id: youtubeModul[0]?.pt_user_id });
      }
    }

    // TikTok
    if (tiktokModul?.length > 0) {
      tiktokModul.map((item) => {
        platform.push({
          id: item.product_id,
          value: item.name,
          label: item.name,
          platform: "tiktok",
          pt_user_id: item.pt_user_id,
        });
      });

      if (tiktokModul.length > 1) {
        tiktokModul.map((item) => {
          followersData.tiktok.push({
            value: item.followers + " Followers",
            id: item.pt_user_id,
            label: item.followers + " Followers",
          });
        });
      } else {
        platform_id_list.tiktok.push({ id: tiktokModul[0].pt_user_id });
      }
    }

    const uniqueArrOfPrd = platform.filter(
      (obj, index, self) =>
        index ===
        self.findIndex((o) => o.id === obj.id && o.label === obj.label)
    );

    setProductList(uniqueArrOfPrd);
    setFollowersList(followersData);
  }, [instModul, fcbkModul, youtubeModul, tiktokModul]);

  const encryptData = (data, secretKey) => {
    return CryptoJS.AES.encrypt(data, secretKey).toString();
  };

  const submitBtnClick = () => {
    // Reset error
    setError(false);

    // Validation
    const timeValidationRequired = !selectedOfferData?.rate;
    const validationFields = {
      product: form.product === "",
      pieceOfContent: form.pieceOfContent === "",
      rate: form.rate === "",
      ...(timeValidationRequired && {
        time: form.time === "",
        timespan: form.timespan === "",
      }),
      hashtag: form.hashtag === "",
      ...(isInfluencerProfilePage && {
        ds_campaign_title: form.ds_campaign_title === "",
        ds_campaign_delivery_info: form.ds_campaign_delivery_info === "",
        ds_campaign_delivery_date: form.ds_campaign_delivery_date === "",
        brand_profile_id: form.brand_profile_id === "",
      }),
    };

    const hasErrors =
      Object.values(validationFields).some(Boolean) ||
      (showFollowersDropdown && form.platform_user_id === "");

    if (hasErrors) {
      setError(true);
      addToast({
        error: true,
        date: new Date(),
        msg: "Please fill in all required fields",
      });
      return;
    }

    if (showFollowersDropdown === true && form.platform_user_id === "") {
      setError(true);
      addToast({
        error: true,
        date: new Date(),
        msg: "Please select an account",
      });
      return;
    }

    // Find the selected product - with safety check
    const selectedProduct = productList.filter(
      (item) => item.id === form.product
    );
    console.log("🚀 ~ submitBtnClick ~ selectedProduct:", selectedProduct);

    if (!selectedProduct) {
      console.error("Product not found:", form.product);
      addToast({
        error: true,
        date: new Date(),
        msg: "Selected product not found. Please try again.",
      });
      return;
    }

    // Get followers count safely
    let followersCount = [];
    if (showFollowersDropdown && selPlatform && selPlatform.value) {
      followersCount = selPlatform.value.split(" ");
    }

    // Get timespan label
    const selectedTimespan = timeFrame.find(
      (item) => item.id === form.timespan
    );
    const timespanLabel = selectedTimespan
      ? selectedTimespan.value
      : form.timespan;

    // Create the new object
    let newObject = {
      followers_count:
        showFollowersDropdown && followersCount.length > 0
          ? followersCount[0].toString()
          : "",
      influencerAccountCount: showFollowersDropdown
        ? followersDropdown.length
        : 1,
      platform_user_id: form.platform_user_id,
      description:
        form.pieceOfContent +
        " " +
        selectedProduct[0].value +
        (selectedOfferData?.rate
          ? ""
          : " (" + form.time + " " + form.timespan + ")") +
        (showFollowersDropdown && followersCount.length > 0
          ? " - Followers count: " + followersCount[0]
          : ""),
      profileName: influencerProfile.display_name,
      profileImage: influencerProfile.profile_img_url,
      price: form.rate,
      to_user_id: influencerProfile.id,
      product: selectedProduct[0].value,
      product_id: selectedProduct[0].id,
      product_name: selectedProduct[0].value,
      time: form.time,
      timespan: form.timespan,
      pieceOfContent: form.pieceOfContent,
      quantity: form.pieceOfContent,
      to_user_type: selectedApplication?.inf_type
        ? selectedApplication?.inf_type
        : influencerUserType,
      cart_item_addedBy: user.data.id,
      ds_campaign_application_id: selectedApplication?.id
        ? selectedApplication?.id
        : undefined,
      tama_payment: paymentEnabled ? 1 : 0,
      hashtag: form.hashtag,
      offer_type: selectedOfferData?.rate ? "product" : "custom",
      ...(isInfluencerProfilePage && {
        ds_campaign_title: form.ds_campaign_title,
        ds_campaign_delivery_info: form.ds_campaign_delivery_info,
        ds_campaign_delivery_date: form.ds_campaign_delivery_date,
        brand_profile_id: form.brand_profile_id,
      }),
    };

    setCartItem(
      // Replace the state
      [
        // with a new array
        ...cartItem, // that contains all the old items
        newObject, // and one new item at the end
      ]
    );
    let encrypteddata = encryptData(
      JSON.stringify([
        // with a new array
        ...cartItem, // that contains all the old items
        newObject, // and one new item at the end
      ]),
      secretKey
    );
    storageHandler.setCartItem(encrypteddata);
    setModal(null);
    setShowCart(true);
  };

  const addToast = (data) => {
    const newToastList = [...toastList];
    if (data.msg) {
      if (data.msg[data.msg.length - 1] === ".")
        data.msg = data.msg.slice(0, -1);
    }
    newToastList.push({ ...data, id: `${Date.now()}-${toastList.length}` });
    setToastList(newToastList);
  };

  useEffect(() => {
    const keyDownHandler = (event) => {
      if (event.key === "Enter") {
        createList.current?.click();
      }
    };
    document.addEventListener("keydown", keyDownHandler);
    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, [form]);

  const changeSpanTime = (item) => {
    updateForm({ timespan: item });
  };

  const changeSelProduct = (item) => {
    const selectedProduct = productList.find((product) => product.id === item);
    if (!selectedProduct) {
      console.error("Product not found for id:", item);
      return;
    }

    updateForm({
      product: selectedProduct.id,
      platform_user_id: selectedProduct.pt_user_id,
    });

    if (!selectedProduct.platform || !followersList[selectedProduct.platform]) {
      console.error("Invalid platform:", selectedProduct.platform);
      setShowFollowersDropdown(false);
      return;
    }

    const platformFollowers = followersList[selectedProduct.platform];

    const uniqueArrOfPrd = platformFollowers.filter(
      (obj, index, self) =>
        index ===
        self.findIndex((o) => o.value === obj.value && o.id === obj.id)
    );

    if (uniqueArrOfPrd.length > 1) {
      setShowFollowersDropdown(true);
      setFollowersDropdown(uniqueArrOfPrd);
    } else if (uniqueArrOfPrd.length === 1) {
      let platformId = uniqueArrOfPrd[0].id;
      setShowFollowersDropdown(false);
      setSelPlatform(uniqueArrOfPrd[0]);
      updateForm({ product: selectedProduct.id, platform_user_id: platformId });
    } else {
      // No accounts found
      setShowFollowersDropdown(false);
      updateForm({
        product: selectedProduct.id,
        platform_user_id: selectedProduct.pt_user_id,
      });
    }
  };
  const changeSelHandle = (temp) => {
    setSelPlatform(temp);
    updateForm({ platform_user_id: temp.id });
  };

  const getSelectedProduct = () => {
    return productList.filter((temp) => temp.id === form.product)[0];
  };

  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };
  const handleStartDateClick = (e) => {
    if (isStartDatePickerOpen) {
      e.currentTarget.blur();
      setIsStartDatePickerOpen(false);
    } else {
      e.currentTarget.showPicker();
      setIsStartDatePickerOpen(true);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      exit={{ opacity: 0, y: 30 }}
      className="assetsAdd"
    >
      <div className="assetsAdd__form">
        <div className="assetsAdd__form-title">
          <h3 className="big">
            {selectedOfferData ? "Create Offer" : "Create a Custom Offer"}
          </h3>
        </div>
        <div
          className="max-h-[65vh] overflow-y-auto pr-2"
          style={{
            scrollbarWidth: "thin",
            scrollbarColor: "#e5e7eb transparent",
          }}
        >
          <div className="assetsAdd__form-inner !mb-2">
            <div className="assetsAdd__form-head">
              <SelectInput
                errorText="Please enter what kind of content do you need?"
                list={productList}
                selected={getSelectedProduct()}
                onChange={isReadOnlyOffer ? () => {} : changeSelProduct}
                label="What kind of content do you need?"
                error={error && form.product === ""}
                value={form.product}
                isRequired
                readOnly={isReadOnlyOffer}
                className={`${
                  error && !form.product ? "border-[#980412] bg-red-50 " : ""
                }`}
              />
            </div>
          </div>
          {showFollowersDropdown && (
            <div className="assetsAdd__form-inner mb-2">
              <div className="assetsAdd__form-head">
                <SelectInput
                  errorText="Please select account"
                  list={followersDropdown}
                  selected={
                    followersDropdown.find(
                      (item) => item.id === form.platform_user_id
                    ) || null
                  }
                  onChange={isReadOnlyOffer ? () => {} : changeSelHandle}
                  label="Select Account"
                  error={error && form.platform_user_id === ""}
                  value={form.platform_user_id}
                  disabled={isReadOnlyOffer}
                />
              </div>
            </div>
          )}
          <div className="grid grid-cols-2 gap-2 mb-2">
            <div className="assetsAdd__form-inner">
              <TextInput
                onChange={
                  isReadOnlyOffer ? () => {} : setInput("pieceOfContent")
                }
                type="number"
                onWheel={(e) => e.target.blur()}
                label="Pieces of content do you need?"
                errorText="Please enter pieces of content do you need"
                readOnly={isReadOnlyOffer}
                error={error && form.pieceOfContent === ""}
                value={form.pieceOfContent}
                isRequired
              />
            </div>
            <div className="assetsAdd__form-inner">
              <TextInput
                onChange={isReadOnlyOffer ? () => {} : setInput("rate")}
                type="number"
                onWheel={(e) => e.target.blur()}
                label="Set a price for your offer"
                errorText="Please enter Price for your offer"
                readOnly={isReadOnlyOffer}
                error={error && form.rate === ""}
                value={form.rate}
                isRequired
              />
            </div>
          </div>
          {!selectedOfferData?.rate && (
            <>
              <div className="addOffer !mb-2">
                <div className="w-full">
                  <TextInput
                    onChange={isReadOnlyOffer ? () => {} : setInput("time")}
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    label="How long should the content be?"
                    errorText="Please enter how long should the content be"
                    readOnly={isReadOnlyOffer}
                    error={error && form.time === ""}
                    value={form.time}
                    isRequired
                  />
                </div>
                <SelectInput
                  onChange={isReadOnlyOffer ? () => {} : changeSpanTime}
                  label="TimeFrame"
                  list={timeFrame}
                  selected={
                    timeFrame.find((item) => item.id === form.timespan) || null
                  }
                  error={error && form.timespan === ""}
                  value={form.timespan}
                  errorText="Please select TimeFrame"
                  isRequired
                  disabled={isReadOnlyOffer}
                  readOnly={isReadOnlyOffer}
                  className={`${
                    error && !form.timespan ? "border-[#980412] bg-red-50 " : ""
                  }`}
                />
              </div>
              {!isInfluencerProfilePage && (
                <div className="!mb-2">
                  <TextInput
                    onChange={setInput("hashtag")}
                    type="text"
                    onWheel={(e) => e.target.blur()}
                    label="Hashtag"
                    errorText=" Please enter hashtag"
                    error={error && form.hashtag === ""}
                    value={form.hashtag}
                    isRequired
                  />
                </div>
              )}
            </>
          )}

          {isInfluencerProfilePage && (
            <>
              <div className="grid grid-cols-2 gap-2 !mb-2">
                <div className="assetsAdd__form-head">
                  <SelectInput
                    errorText="Please select brand profile"
                    list={brandProfilesList}
                    selected={getSelectedBrandProfile()}
                    onChange={changeBrandProfile}
                    label="Brand Profile"
                    error={error && form.brand_profile_id === ""}
                    value={form.brand_profile_id}
                    isRequired
                    className={`p-3 ${
                      error && !form.brand_profile_id
                        ? "border-[#980412] bg-red-50 "
                        : ""
                    }`}
                  />
                </div>

                {/* Delivery Date */}
                <div className="">
                  <label className="block text-[14px] text-black font-semibold  mb-1">
                    Campaign Delivery Date{" "}
                    <span className="text-red-400">*</span>
                  </label>
                  <div
                    className={`border p-[9px] border-gray-200 rounded-md ${
                      error && !form.ds_campaign_delivery_date
                        ? "!border-[#980412] bg-red-50 "
                        : ""
                    }`}
                  >
                    <input
                      type="date"
                      id="ds_campaign_delivery_date"
                      value={form.ds_campaign_delivery_date}
                      onChange={setInput("ds_campaign_delivery_date")}
                      min={getTodayDate()}
                      onKeyDown={(e) => e.preventDefault()}
                      onClick={handleStartDateClick}
                      className={`bg-white w-full outline-none cursor-pointer text-black disabled:opacity-50 disabled:cursor-not-allowed [&::-webkit-calendar-picker-indicator]:cursor-pointer ${
                        error && !form.ds_campaign_delivery_date
                          ? "!bg-red-50 border-[#980412]"
                          : ""
                      }`}
                    />
                  </div>
                  {error && !form.ds_campaign_delivery_date && (
                    <p className="text-[#980412] text-[12px] flex items-center gap-2">
                      Please enter campaign delivery date
                    </p>
                  )}
                </div>
              </div>
              <div className="!mb-2">
                <TextInput
                  onChange={setInput("ds_campaign_title")}
                  type="text"
                  onWheel={(e) => e.target.blur()}
                  label="Campaign Title"
                  errorText=" Please enter campaign title"
                  error={error && form.ds_campaign_title === ""}
                  value={form.ds_campaign_title}
                  isRequired
                />
              </div>
              <div className="!mb-2">
                <TextInput
                  onChange={setInput("hashtag")}
                  type="text"
                  onWheel={(e) => e.target.blur()}
                  label="Hashtag"
                  errorText=" Please enter hashtag"
                  error={error && form.hashtag === ""}
                  value={form.hashtag}
                  isRequired
                />
              </div>
              <div className="">
                <AppTextArea
                  onChange={setInput("ds_campaign_delivery_info")}
                  type="text"
                  rows={3}
                  onWheel={(e) => e.target.blur()}
                  label="Campaign Delivery Information"
                  errorText=" Please enter campaign delivery information"
                  error={error && form.ds_campaign_delivery_info === ""}
                  value={form.ds_campaign_delivery_info}
                  isRequired
                  textAreaLable="!text-black !font-semibold"
                  errorClassName="!text-[12px] !text-[#980412]"
                  className={`focus:ring-0 focus:outline-none ${
                    error && form.ds_campaign_delivery_info === ""
                      ? "border-[#980412] bg-red-50"
                      : "!focus-within:ring-transparent "
                  }`}
                />
              </div>
            </>
          )}
        </div>
      </div>

      <div className="campaignsCreate__btns">
        <div className="campaignsCreate__btns-row">
          <SwitchWithLabel
            id="notifications"
            label="Payments Handled By TAMA"
            labelRight=""
            className=""
            checked={paymentEnabled}
            onCheckedChange={setPaymentEnabled}
          />
        </div>
        <button
          ref={createList}
          className="button primary"
          onClick={submitBtnClick}
        >
          Add To Cart
        </button>
      </div>
    </motion.div>
  );
}
